import { Button, TextField, IconButton, MenuItem, Tooltip } from "@mui/material";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import React, { useContext } from "react";
import NumberFormat from "react-number-format";

import format from "date-format";
import { net } from "../../../../../database";
import Receipt from "../../../components/Receipt";
import HistoryIcon from "@mui/icons-material/History";
import { useNavigate } from "react-router-dom";
import PaymentDialog from "../../owed/components/PaymentDialog";

import ChangeCredit from "./ChangeCredit";
import { CenterContext, UserContext } from "../../../../../Context";
import PaymentHistory from "./PaymentHistory";

export default function UnpaidBills(props) {
  let { customer, setCustomer } = props;
  const { center } = useContext(CenterContext);
  const { user } = useContext(UserContext);
  const { students } = customer;
  const [open, setOpen] = React.useState(false);
  const [openCC, setOpenCC] = React.useState(false);
  const [receipt, setReceipt] = React.useState(undefined);
  let navigate = useNavigate();

  // Aggregate and sort all bills
  let allUnpaidBills = [];
  let totalOwed = 0;

  students.forEach((student) => {
    student.unpaidBills?.forEach((bill) => {
      allUnpaidBills.push({ ...bill, studentName: student.name });
      totalOwed += parseInt(bill.amount) || 0;
    });
  });

  // Sort by date (newest first)
  allUnpaidBills.sort((a, b) => new Date(b.date) - new Date(a.date));

  const updateCustomer = (update) => {
    net
      .post(`/customers/${customer._id}`, update)
      .then(() => setCustomer({ ...customer, ...update }));
  };

  const openDialog = () => {
    setOpen(true);
  };

  const closePaymentDialog = () => {
    net.get(`/customer/${customer._id}`).then((updated) => {
      setCustomer(updated);
    });
    setOpen(false);
  };

  return (
    <div className="financial-tab-container">
      <header className="flex justify-between items-center mb-6">
        <h2 className="roster-title">Unpaid Bills</h2>
        <div className="flex items-center gap-4">
          <TextField
            select
            label="Pays on date"
            sx={{ width: 140 }}
            value={customer.paysOnDayOfMonth || 1}
            size="small"
            onChange={(e) => updateCustomer({ paysOnDayOfMonth: e.target.value })}
          >
            {Array.from({ length: 30 }, (_, i) => i + 1).map((day) => (
              <MenuItem key={`payday-${day}`} value={day}>{day}</MenuItem>
            ))}
          </TextField>
          <Tooltip title="View Payment History">
            <IconButton 
              onClick={() => navigate(`/customer/${customer._id}/paymenthistory`)}
              sx={{ color: 'var(--customer-text-secondary)' }}
            >
              <HistoryIcon />
            </IconButton>
          </Tooltip>
        </div>
      </header>

      {allUnpaidBills.length > 0 ? (
        <div className="financial-list-container">
          <table className="financial-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Student</th>
                <th>Type</th>
                <th>Description</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {allUnpaidBills.map((bill) => (
                <tr key={bill._id}>
                  <td className="whitespace-nowrap font-medium text-slate-500">
                    {format("dd/MM/yyyy", new Date(bill.date))}
                  </td>
                  <td>
                    <span className="student-tag-sm">{bill.studentName}</span>
                  </td>
                  <td>
                    <span className="bill-type-tag">{bill.billType}</span>
                  </td>
                  <td className="text-slate-600 italic">{bill.description}</td>
                  <td className="bill-amount">
                    <NumberFormat
                      value={bill.amount}
                      thousandSeparator={true}
                      displayType="text"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-16 bg-slate-50 rounded-xl border border-dashed border-slate-200">
          <div className="text-4xl mb-2">🎉</div>
          <div className="text-slate-500 font-medium italic">All bills are paid! No outstanding amounts.</div>
        </div>
      )}

      {/* Financial Action & Summary */}
      <footer className="pay-now-container">
        {customer.credit > 0 && (
          <div className="credit-summary-card">
            <div className="flex items-center gap-3">
              <span className="text-emerald-700/60 uppercase text-[10px] font-black tracking-widest leading-none">Available Credit</span>
              <span className="text-xl leading-none">
                <NumberFormat
                  value={customer.credit}
                  displayType="text"
                  thousandSeparator={true}
                />
              </span>
            </div>
            {user.roles.includes("Accountant") && (
              <Button 
                variant="outlined" 
                color="success" 
                size="small" 
                onClick={() => setOpenCC(true)} 
                sx={{ borderRadius: '8px', fontWeight: 800, textTransform: 'none' }}
              >
                Adjust Credit
              </Button>
            )}
          </div>
        )}

        <Button
          className="pay-now-button"
          onClick={openDialog}
        >
          <div className="pay-now-label">
            <AttachMoneyIcon fontSize="large" />
            <span className="font-black uppercase tracking-tight">Process Payment</span>
          </div>
          <div className="pay-now-amount">
            <span className="text-[10px] uppercase font-black mr-3 opacity-60">Total Due:</span>
            <NumberFormat
              value={totalOwed - customer.credit}
              displayType="text"
              thousandSeparator={true}
            />
          </div>
        </Button>
      </footer>


      <PaymentDialog
        customerId={customer._id}
        open={open}
        setOpen={setOpen}
        user={user}
        center={center}
        onSuccess={closePaymentDialog}
      />
      <Receipt receipt={receipt} user={user} setReceipt={setReceipt} />
      <ChangeCredit {...props} open={openCC} setOpen={setOpenCC} />
      <PaymentHistory />
    </div>
  );
}

